import { FaceSwapDataObject } from '@/scenes/Editor/components/FloatingImprover/faceSwapStaticData'
import { createAction } from '@reduxjs/toolkit'

export const setAIFilters = createAction<any[]>('aiFilter/setAIFilters')
export const setStyleFromCreatePage = createAction<FaceSwapDataObject>('aiFilter/setStyleFromCreatePage')
/** WP / bridge handoff: expand this Magic Templates category once filters load. */
export const setPendingMagicTemplatesCategoryId = createAction<string | null>(
  'aiFilter/setPendingMagicTemplatesCategoryId',
)
